// extracted by mini-css-extract-plugin
export default {"form":"viewQuiz_form__jIL+2","addButton":"viewQuiz_addButton__YBdmH","backButton":"viewQuiz_backButton__7Re4Q"};